import React from 'react';
import { NavLink } from "react-router-dom";
import "../../css/Portfolio.css";
import useProvider from './../../Hooks/useProvider';
const Portfolio = () => {
    const data = useProvider();
    const { portfolioData } = data.data;

    return (
        <div className="portfolio">
            <h1 className="portfolio__heading">MY PROJECTS </h1>
            <div className="portfolio__container">
                {
                    portfolioData.map(item => {
                        const { id, images, name, full_img, link, description, tools } = item;
                        return (
                            <div className="portfolio__item">
                                <div className="browse__icon">
                                    <p className="bullet"></p>
                                    <p className="bullet"></p>
                                    <p className="bullet"></p>
                                </div>
                                
                                <NavLink className="details" to={`/portfolio_details/${id}`}>
                                    <img className="portfolio__img" src={`${full_img}.png`} alt="website-img" />
                                </NavLink>

                                {/*  <h5 className="portfolio__name">{name} </h5>
                                <p className="portfolio__details">{description} </p>
                                <div className="portfolio__btns">
                                    <a href={link} target="_blank" rel="noreferrer" className="live">live link </a>
                                </div>
                              */}
                            </div>
                        )
                    })
                }

            </div>
        </div>
    )
}

export default Portfolio;